/* Sultanea Club: almacenamiento primero en sultanea.es, no solo en iframe externo.
 * El mensaje contiene un token firmado existente, nunca el perfil completo.
 * No crea ni modifica clientes, pedidos o puntos.
 */
(function () {
  'use strict';
  if (window.__sultaneaClubBridgeV1) return;
  window.__sultaneaClubBridgeV1 = true;
  // Ventajas Club: presentación exclusiva de esta copia borrador.
  function updateClubBenefits(){
    const root=document.getElementById('su-club-benefits-lifetime');
    if(root)return;
    const heading=Array.from(document.querySelectorAll('body *')).find(el=>el.children.length===0&&el.textContent.trim().toUpperCase()==='TUS VENTAJAS CLUB');
    if(!heading)return;
    let card=heading.parentElement;
    for(let n=0;n<5&&card;n++,card=card.parentElement){
      const content=card.textContent||'';
      if(content.includes('5%-15% EN')&&content.includes('ACUMULA EL 1'))break;
    }
    if(!card||!card.textContent.includes('ACUMULA EL 1'))return;
    const wrapper=document.createElement('div');
    wrapper.id='su-club-benefits-lifetime';
    wrapper.style.cssText='text-align:center;padding:24px 14px;color:#d5b474;font-family:inherit';
    const eyebrow=document.createElement('p');
    eyebrow.style.cssText='letter-spacing:.15em;font-size:15px;margin:0 0 20px';
    eyebrow.textContent='TUS VENTAJAS SULTANEA CLUB';
    const title=document.createElement('h2');
    title.style.cssText='color:#d5b474;font-size:clamp(23px,5vw,38px);line-height:1.3;font-weight:500;margin:0 0 18px';
    title.textContent='SOLO POR SER DEL CLUB';
    const lines=[
      '5 % de descuento de por vida en todos los perfumes',
      '15 % de descuento de por vida en la segunda unidad',
      '1 % de tus compras acumulado en saldo Club'
    ];
    wrapper.append(eyebrow,title);
    lines.forEach(line=>{
      const p=document.createElement('p');
      p.style.cssText='font-size:clamp(16px,3.5vw,22px);line-height:1.5;margin:14px 0;color:#f1e3c7';
      p.textContent=line;
      wrapper.appendChild(p);
    });
    card.replaceChildren(wrapper);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',updateClubBenefits,{once:true});
  else updateClubBenefits();
  const STORE_KEY = 'sultaneaClubSignedCardV1';
  const MESSAGE_TYPE = 'sultanea-club-storage-v1';
  // Exclusivamente en el tema borrador: backend de la rama de pruebas.
  const APP_ORIGIN = 'https://sultanea-perfume.vercel.app';
  const CARD_RE = /^[A-Za-z0-9_-]{20,2500}\.[A-Za-z0-9_-]{20,250}$/;
  let frame = null;
  let lastSaved = null;
  let topCard = null;
  let cardRegistration = null;
  let cardFormLink = null;

  function getFrame() {
    const f = document.querySelector('iframe[title="Registro Sultanea Club"]');
    if (!f || !f.src || !f.contentWindow) return null;
    try {
      const url = new URL(f.src, window.location.href);
      return url.origin === APP_ORIGIN && url.pathname === '/api/club' ? f : null;
    } catch (_) {
      return null;
    }
  }
  function readSaved() {
    try {
      const token = window.localStorage.getItem(STORE_KEY);
      return token && CARD_RE.test(token) ? token : null;
    } catch (_) {
      return lastSaved;
    }
  }
  function notifyClubTokenChanged() {
    try { window.dispatchEvent(new Event('sultanea-club-token-changed')); } catch (_) {}
  }
  function saveToken(token) {
    lastSaved = token;
    try { window.localStorage.setItem(STORE_KEY, token); } catch (_) {}
    notifyClubTokenChanged();
  }
  function deleteSaved() {
    lastSaved = null;
    try { window.localStorage.removeItem(STORE_KEY); } catch (_) {}
    notifyClubTokenChanged();
  }
  function getReferral() {
    const r = new URLSearchParams(window.location.search).get('ref') || '';
    return /^SC-[0-9]{5,20}-[A-Za-z0-9_-]{16}$/.test(r) ? r : '';
  }
  function syncToIframe() {
    const f = getFrame();
    if (!f) return;
    frame = f;
    // Repetimos la negociación aunque se pierda el primer aviso 'ready'.
    f.contentWindow.postMessage({type:MESSAGE_TYPE,action:'ui-v2'},APP_ORIGIN);
    f.contentWindow.postMessage({type:MESSAGE_TYPE,action:'sync',token:readSaved(),ref:getReferral()},APP_ORIGIN);
  }

  function elt(tag, className, content) {
    const node = document.createElement(tag);
    if (className) node.className=className;
    if (content!==undefined) node.textContent=content;
    return node;
  }
  function buildPremiumCard() {
    if (topCard) return topCard;
    const form = document.getElementById('registro-club');
    const pageRoot = form?.parentElement;
    if (!pageRoot || !form) return null;
    cardRegistration=form;
    cardFormLink=pageRoot.querySelector('a[href="#registro-club"]');
    const outer=elt('section');
    outer.id='su-club-card-top';
    outer.setAttribute('aria-label','Tu tarjeta Sultanea Club');
    outer.hidden=true;
    outer.appendChild(elt('p','su-club-card-heading','TU TARJETA SULTANEA CLUB'));
    const card=elt('div','su-club-credit-card');
    const header=elt('div','su-club-credit-top');
    header.appendChild(elt('span','su-club-credit-name','SULTANEA CLUB'));
    const crown=elt('span','su-club-credit-crown');
    crown.innerHTML='<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M6 16l8 8 10-15 10 15 8-8-5 23H11L6 16Z"/><path d="M11 34h26M12 40h24M24 5v7M20 8h8"/><circle cx="6" cy="13" r="2"/><circle cx="42" cy="13" r="2"/><circle cx="24" cy="6" r="2"/></svg>';
    crown.setAttribute('aria-hidden','true');
    header.appendChild(crown);
    card.appendChild(header);
    const person=elt('div','su-club-credit-person');
    person.appendChild(elt('span','su-club-credit-label','MIEMBRO'));
    const name=elt('strong');name.id='su-club-card-person';name.textContent='';person.appendChild(name);
    card.appendChild(person);
    const values=elt('div','su-club-credit-values');
    const codeWrap=elt('div');
    codeWrap.appendChild(elt('span','su-club-credit-label','CÓDIGO DE MIEMBRO'));
    const code=elt('div','su-club-credit-code');code.id='su-club-card-code';codeWrap.appendChild(code);values.appendChild(codeWrap);
    const metrics=elt('div','su-club-credit-metrics');
    for(const entry of [['SALDO CLUB','su-club-card-balance']]) {
      const metric=elt('div','su-club-credit-metric');
      metric.appendChild(elt('span','su-club-credit-label',entry[0]));
      const number=elt('strong');number.id=entry[1];metric.appendChild(number);
      metrics.appendChild(metric);
    }
    const earnings=elt('p','su-club-credit-pending');
    earnings.id='su-club-pending-earnings';
    earnings.hidden=true;
    metrics.appendChild(earnings);
    values.appendChild(metrics);
    card.appendChild(values);
    const bar=elt('div','su-club-credit-barcode');
    const img=elt('img');img.id='su-club-card-barcode';img.alt='Código de barras real de Sultanea Club';bar.appendChild(img);
    card.appendChild(bar);
    outer.appendChild(card);
    outer.appendChild(elt('p','su-club-card-foot','Presenta este código de barras en caja para identificarte.'));
    const actions=elt('div','su-club-card-actions');
    const manage=elt('button',null,'CAMBIAR O RECUPERAR TARJETA');
    manage.type='button';
    manage.addEventListener('click',() => {
      if (!cardRegistration) return;
      cardRegistration.style.display='';
      cardRegistration.scrollIntoView({behavior:'smooth',block:'start'});
    });
    actions.appendChild(manage);
    outer.appendChild(actions);

    // Diseño real del cartel de Sultanea, pero con QR de referido INDIVIDUAL.
    // El QR genérico de la imagen se cubre completamente, no se comparte nunca.
    const invitation=elt('section','su-club-referral');
    invitation.id='su-club-referral';
    invitation.style.display='none';
    const art=elt('div','su-club-referral-art');
    const poster=elt('img','su-club-referral-poster');
    poster.src='https://cdn.shopify.com/s/files/1/0934/1114/8105/files/sultanea-club-cartel-diseno-invitacion.png?v=1792243676';
    poster.alt='Cartel Sultanea Club negro y dorado, con corona y marco decorativo';
    poster.loading='lazy';
    art.appendChild(poster);
    const copy=elt('div','su-club-referral-copy');
    copy.appendChild(elt('strong',null,'COMPARTE Y GANA 3 €'));
    copy.appendChild(elt('span',null,'Tu invitación personal'));
    art.appendChild(copy);
    const qrWindow=elt('div','su-club-referral-qr-window');
    const qr=elt('img');qr.id='su-club-referral-qr';
    qr.alt='Código QR personal para recomendar Sultanea Club';
    qr.loading='lazy';
    qrWindow.appendChild(qr);
    art.appendChild(qrWindow);
    const caption=elt('div','su-club-referral-poster-foot','TU QR PERSONAL DE INVITACIÓN');
    art.appendChild(caption);
    invitation.appendChild(art);
    invitation.appendChild(elt('p','su-club-referral-terms','Comparte tu QR. Si alguien se registra como nuevo socio desde tu invitación y su primera compra pagada es de 100 € o más, recibirás 3 € de saldo Club tras 15 días, siempre que la compra sea válida y no se devuelva.'));
    const link=elt('p','su-club-referral-url');link.id='su-club-referral-url';invitation.appendChild(link);
    const btn=elt('button','su-club-referral-share','COMPARTIR MI INVITACIÓN');
    btn.id='su-club-referral-share';btn.type='button';
    invitation.appendChild(btn);
    invitation.appendChild(elt('p','su-club-referral-status',''));
    outer.appendChild(invitation);
    pageRoot.insertBefore(outer,pageRoot.firstChild);
    topCard=outer;
    return outer;
  }
  function showRegistration() {
    if (topCard) topCard.hidden=true;
    if (cardRegistration) cardRegistration.style.display='';
    if (cardFormLink) cardFormLink.style.display='';
  }
  function showPremiumCard(payload,scroll) {
    if (!payload || typeof payload!=='object')return;
    const m=payload.member, src=payload.barcodeDataUrl;
    if(!m||typeof m!=='object'||typeof m.name!=='string'||typeof m.memberCode!=='string')return;
    if(!/^SUL-\d{8}$/.test(m.memberCode)||!Number.isFinite(Number(m.euroBalance)))return;
    if(typeof src!=='string'||!/^data:image\/png;base64,[A-Za-z0-9+/=]+$/.test(src)||src.length>200000)return;
    const section=buildPremiumCard();
    if(!section)return;
    document.getElementById('su-club-card-person').textContent=m.name.toUpperCase().slice(0,85);
    document.getElementById('su-club-card-code').textContent=m.memberCode;
    document.getElementById('su-club-card-balance').textContent=Number(m.euroBalance).toLocaleString('es-ES',{style:'currency',currency:'EUR'});
    const pendingInfo=document.getElementById('su-club-pending-earnings');if(pendingInfo)pendingInfo.hidden=true;
    document.getElementById('su-club-card-barcode').src=src;
    // Renderizar el código debajo de las barras como texto HTML nítido.
    // El PNG Code128 original permanece intacto para escanearlo en caja.
    const barcodeBox=document.querySelector('#su-club-card-top .su-club-credit-barcode');
    if(barcodeBox)barcodeBox.setAttribute('data-member-number',m.memberCode.replace(/-/g,''));

    const share=payload.invitation;
    const inviteSection=document.getElementById('su-club-referral');
    if(inviteSection) {
      const url=typeof share?.url==='string'?share.url:'';
      const img=typeof share?.qrDataUrl==='string'?share.qrDataUrl:'';
      if(url.startsWith('https://sultanea.es/club?ref=') && /^data:image\/png;base64,[A-Za-z0-9+/=]+$/.test(img) && img.length<250000){
        document.getElementById('su-club-referral-qr').src=img;
        document.getElementById('su-club-referral-url').textContent='Tu enlace personal está listo para compartir';
        document.getElementById('su-club-referral-share').onclick=async()=>{
          try{
            if(navigator.share){await navigator.share({title:'Sultanea Club',text:'Te invito a Sultanea Club',url});return}
            await navigator.clipboard.writeText(url);
            document.querySelector('.su-club-referral-status').textContent='Enlace copiado.';
          }catch(_){document.querySelector('.su-club-referral-status').textContent='No se ha podido copiar. Prueba de nuevo.'}
        };
        // Solo recuento agregado: nunca mostrar nombres de personas invitadas.
        let counter=document.getElementById('su-club-referral-count');
        if(!counter){
          counter=document.createElement('p');
          counter.id='su-club-referral-count';
          counter.style.cssText='margin:16px auto 4px;max-width:560px;padding:13px 14px;border-radius:13px;background:#18120d;color:#e3c27d;text-align:center;font:700 clamp(16px,3.8vw,21px)/1.45 Arial,sans-serif;letter-spacing:.02em';
          inviteSection.appendChild(counter);
        }
        const registered=payload.referrals?.registered;
        if(Number.isSafeInteger(registered)&&registered>=0){
          counter.textContent='PERSONAS QUE HAS INVITADO: '+registered;
          counter.hidden=false;
        }else counter.hidden=true;

        counter.setAttribute('role','button');
        counter.setAttribute('tabindex','0');
        counter.setAttribute('aria-expanded','false');
        counter.style.cursor='pointer';
        counter.style.userSelect='none';
        let panel=document.getElementById('su-club-referrals-panel');
        if(!panel){
          panel=document.createElement('div');
          panel.id='su-club-referrals-panel';
          panel.hidden=true;
          panel.style.cssText='max-width:560px;margin:8px auto 18px;padding:15px;border:1px solid #c6a66d;border-radius:12px;background:#fffaf1;color:#342719;text-align:left;font:15px/1.6 Arial,sans-serif';
          counter.insertAdjacentElement('afterend',panel);
        }
        const toggle=async()=>{
          if(!panel.hidden){panel.hidden=true;counter.setAttribute('aria-expanded','false');return;}
          panel.hidden=false;counter.setAttribute('aria-expanded','true');
          panel.textContent='Cargando tus invitados…';
          try{
            const token=readSaved();
            if(!token)throw Error('CARD_REQUIRED');
            const response=await fetch(APP_ORIGIN+'/api/club-recover',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({action:'referrals-list',cardToken:token})});
            if(!response.ok)throw Error('UNAVAILABLE');
            const data=await response.json();
            if(!data.ok||!Array.isArray(data.referrals))throw Error('UNAVAILABLE');
            panel.replaceChildren();
            if(!data.referrals.length){panel.textContent='Todavía no hay personas registradas con tu invitación.';return;}
            const heading=document.createElement('div');
            heading.style.cssText='font-weight:700;color:#795b2d;margin-bottom:8px';
            heading.textContent='Tus invitados: '+data.referrals.length;
            panel.appendChild(heading);
            const list=document.createElement('ol');
            list.style.cssText='margin:0;padding-left:24px';
            const validDate=value=>{
              if(!value)return null;
              const date=new Date(value);
              return Number.isNaN(date.getTime())?null:date.toLocaleDateString('es-ES',{day:'2-digit',month:'long',year:'numeric'});
            };
            data.referrals.forEach(person=>{
              const li=document.createElement('li');
              li.style.cssText='padding:12px 0;border-bottom:1px solid #e6d7bd';
              const name=document.createElement('div');
              name.style.cssText='font-weight:700;font-size:16px;color:#261b11';
              name.textContent=String(person.name||'Socio del Club');
              li.appendChild(name);
              const joined=validDate(person.joined);
              if(joined){
                const date=document.createElement('div');
                date.style.cssText='font-size:13px;color:#6d604c';
                date.textContent='Registrado el '+joined;
                li.appendChild(date);
              }
              const status=document.createElement('div');
              status.style.cssText='font-size:14px;margin-top:5px;color:#926b2d';
              status.textContent='Recompensa de 3 €: pendiente de verificación';
              li.appendChild(status);
              list.appendChild(li);
            });
            panel.appendChild(list);
            const note=document.createElement('p');
            note.style.cssText='font-size:12px;line-height:1.5;color:#756b5c;margin:14px 0 0';
            note.textContent='Los 3 € solo se generan si la primera compra pagada del invitado es de 100 € o más y no se devuelve. Se abonan tras 15 días. El estado de cada compra aún no está disponible en esta lista.';
            panel.appendChild(note);
          }catch(_){panel.textContent='No se ha podido cargar la lista. Inténtalo de nuevo.';}
        };
        if(!counter.dataset.referralsBound){
          counter.addEventListener('click',toggle);
          counter.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();toggle();}});
          counter.dataset.referralsBound='1';
        }
        inviteSection.style.display='block';
      } else inviteSection.style.display='none';
    }
    section.hidden=false;
    if(cardRegistration)cardRegistration.style.display='none';
    if(cardFormLink)cardFormLink.style.display='none';
    if(scroll)window.requestAnimationFrame(()=>section.scrollIntoView({behavior:'smooth',block:'start'}));
  }
  function onMessage(event) {
    if (event.origin !== APP_ORIGIN) return;
    const f = getFrame();
    if (!f || event.source !== f.contentWindow) return;
    const data = event.data;
    if (!data || data.type !== MESSAGE_TYPE) return;
    frame = f;
    if (data.action === 'ready') {
      syncToIframe();
    } else if (data.action === 'card:update') {
      showPremiumCard(data, data.scroll === true);
    } else if (data.action === 'card:cashback-pending') {
      const activeCode=document.getElementById('su-club-card-code')?.textContent||'';
      const earned=data.amountCents;
      if(data.memberCode!==activeCode || !Number.isSafeInteger(earned) || earned<0 || earned>100000000) return;
      const area=document.getElementById('su-club-pending-earnings');
      if(area){
        area.textContent='PENDIENTE · '+(earned/100).toLocaleString('es-ES',{style:'currency',currency:'EUR'})+' (no canjeable)';
        area.hidden=false;
      }
    } else if (data.action === 'save') {
      if (typeof data.token !== 'string' || !CARD_RE.test(data.token)) return;
      saveToken(data.token);
    } else if (data.action === 'forget') {
      deleteSaved();
      showRegistration();
    }
  }
  window.addEventListener('message',onMessage);
  // Solo el tema de pruebas: añadir una ventaja visible en la página Club
  // sin modificar el contenido compartido de Shopify ni prometer saldo activo.
  function showCashbackBenefit() {
    if(!document.getElementById('registro-club')) return;
    if(document.getElementById('su-club-cashback-benefit')) return;
    const headings=Array.from(document.querySelectorAll('div')).filter(el=>el.children.length===0 && (el.textContent||'').trim()==='TUS VENTAJAS CLUB');
    const heading=headings[0],tier=heading?.nextElementSibling;
    if(!tier || !/5%\s*[–-]\s*15%\s*EN PERFUMES/i.test(tier.textContent||''))return;
    const benefit=document.createElement('p');
    benefit.id='su-club-cashback-benefit';
    benefit.innerHTML='ACUMULA EL 1 % DE TUS COMPRAS<span style="display:block;font-size:.65em;line-height:1.5;letter-spacing:.14em;margin-top:6px">EN SALDO CLUB</span>';
    benefit.style.cssText='margin:14px auto 16px;padding:12px 10px;border:1px solid rgba(226,192,120,.45);border-radius:10px;max-width:520px;font:700 clamp(15px,3.6vw,19px)/1.45 Arial,sans-serif;color:#e2c078;text-align:center';
    tier.insertAdjacentElement('afterend',benefit);
  }
  function init() {
    showCashbackBenefit();
    // En la página Club se elimina solamente el bloque genérico compartido
    // sin modificar el contenido global de Shopify ni sus otras páginas.
    const oldQR=document.querySelector('img[src*="sultanea-club-qr.png"]');
    const oldSection=oldQR?.parentElement;
    if(oldSection && /Comparte Sultanea Club/i.test(oldSection.querySelector('h2')?.textContent||'')){
      oldSection.style.display='none';
    }
    // La página Shopify /club es compartida por temas; solo este tema
    // sustituye el iframe remoto por la versión Preview.
    frame = getFrame();
    if (!frame) return;
    frame.addEventListener('load',syncToIframe);
    // Si el iframe ya cargó antes que nosotros, activar modo tarjeta ahora.
    syncToIframe();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',init,{once:true});
  } else {
    init();
  }
})();
